import { render, staticRenderFns } from "./OurApproach.vue?vue&type=template&id=dea935a6&"
import script from "./OurApproach.vue?vue&type=script&lang=js&"
export * from "./OurApproach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports